module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block"
  }, [_c('div', {
    staticClass: "demo-block-preview"
  }, [_vm._t("preview")], 2), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code"
  }, [_c('div', {
    staticClass: "demo-block-code-box"
  }, [_c('h3', [_vm._v("Vue Component & Webpack")]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box-content"
  }, [_c('pre', [_vm._v("             "), _c('code', {
    ref: "vueCode",
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm._f("code")(_vm.vueCode)))]), _vm._v("\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box"
  }, [_c('h3', [_vm._v("HTML & JS")]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box-content"
  }, [_c('pre', [_vm._v("          "), _c('code', {
    ref: "htmlCode",
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm._f("code")(_vm.htmlCode)) + "\n          ")]), _vm._v("\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-213df8bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demos/components/demo-block.vue
// module id = 324
// module chunks = 1